export default "/_next/static/images/2022-2x-c07fcfc9e081da9f3334d8d3feddc8cc.png";